<template>
    <Pagination
        v-slot="{ page }"
        :items-per-page="itemsPerPage"
        :total="totalItems"
        :sibling-count="1"
        show-edges
        :default-page="currentPage"
        @update:page="handlePageUpdate"
        class="mt-10 w-full px-[var(--padding-base)] sm:mx-auto sm:mt-12 sm:max-w-[465px] lg:mt-20"
    >
        <PaginationList
            v-slot="{ items }"
            class="flex items-center justify-between"
        >
            <PaginationPrev class="text-base-black" />
            <div class="slt-flex-center gap-2">
                <template v-for="(item, index) in items">
                    <PaginationListItem
                        v-if="item.type === 'page'"
                        :key="index"
                        :value="item.value"
                        as-child
                    >
                        <button
                            :class="
                                twMerge(
                                    'h-8 w-8 rounded-[.5rem] p-0',
                                    item.value === page
                                        ? ' bg-base-black text-base-white'
                                        : ' bg-base-silver text-base-black transition-all duration-200 hover:text-base-black',
                                )
                            "
                        >
                            <AtomsH6>
                                {{ item.value }}
                            </AtomsH6>
                        </button>
                    </PaginationListItem>

                    <PaginationEllipsis
                        v-else
                        :key="item.type"
                        :index="index"
                        class="h-8 w-4 items-end text-base-black"
                    />
                </template>
            </div>
            <PaginationNext class="text-base-black" />
        </PaginationList>
    </Pagination>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import {
    Pagination,
    PaginationList,
    PaginationListItem,
    PaginationEllipsis,
    PaginationPrev,
    PaginationNext,
} from "@/components/ui/pagination";

const {
    currentPage,
    totalPages,
    itemsPerPage = 10,
} = defineProps<{
    currentPage: number;
    totalPages: number;
    itemsPerPage?: number;
}>();

// --- Emits ---
const emit = defineEmits<{
    (e: "update:currentPage", page: number): void;
}>();

// --- Computed ---
// Calculate total items based on total pages and items per page
// The underlying Shadcn component likely expects total *items*
const totalItems = computed(() => totalPages * itemsPerPage);

// --- Methods ---
// Handle the update event from the underlying Pagination component
function handlePageUpdate(newPage: number) {
    emit("update:currentPage", newPage);
}
</script>
